import { env } from 'config/env';

export const shellbarTicketConfig = (): string => {
  const description = `<p>Browser/version: E.g. Chrome, latest version</p><br><p>Environment Found: E.g. Development, Acceptance, Internal Productive.</p><br><p>Description of the issue:</p><p>When doing A, result 2 happened.</p><br><p>Expected Result:</p><p>- When performing action A, the result should be 1 and not 2.</p><br><p>Repro Steps:</p><p>1. Log in application X</p><p>2. Click on Menu Y</p><p>3. When the page loads, Click on field Z</p>`;

  return (
    'https://itsm.services.sap/sp' +
    '?id=sc_cat_item' +
    '&sys_id=b760c5611b5b78d4614e744c8b4bcbd7' +
    '&sysparm_category=e15706fc0a0a0aa7007fc21e1ab70c2f' +
    '&priority=4' +
    '&u_app_component=LOD-TH-QM' +
    '&system=TST' +
    '&main_impact=functionality' +
    `&description=${description}`
  );
};

export const shellbarFeedbackConfig = (): string => {
  return `https://sapit-home-prod-004.launchpad.cfapps.eu10.hana.ondemand.com/site#feedbackservice-Display&/topic/ea495cc5-965e-4635-9b2f-e0b3dd8e62de`;
};

export const shellbarDocumentationInternalConfig = (): string => {
  return `${env?.REACT_APP_DOCS_INTERNAL}`;
};

export const shellbarDocumentationLSPConfig = (): string => {
  return `${env?.REACT_APP_DOCS_LSP}`;
};
